module.exports = __webpack_public_path__ + "img/logo.24356a64.jpeg";